import { api } from '@/lib/api';

// Admin CRUD helpers
const ent = (name) => ({
    list: () => api.get(`/admin/${name}`).then((r) => r.data),
    create: (data) => api.post(`/admin/${name}`, data).then((r) => r.data),
    update: (slug, data) => api.put(`/admin/${name}/${slug}`, data).then((r) => r.data),
    remove: (slug) => api.delete(`/admin/${name}/${slug}`).then((r) => r.data),
});

export const adminArtists = ent('artists');
export const adminArtworks = ent('artworks');
export const adminExhibitions = ent('exhibitions');
export const adminJournal = ent('journal');
export const adminVideos = ent('videos');

export const adminEnquiries = () => api.get('/admin/enquiries').then((r) => r.data);
export const adminNewsletter = () => api.get('/admin/newsletter').then((r) => r.data);

// Soft-hide endpoints — the records stay in the database, they just
// stop appearing in the admin overview. Both accept an array of ids.
export const hideEnquiries = (ids) =>
    api.post('/admin/enquiries/hide', { ids }).then((r) => r.data);
export const hideNewsletter = (ids) =>
    api.post('/admin/newsletter/hide', { ids }).then((r) => r.data);

export const uploadImage = (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return api.post('/admin/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then((r) => r.data);
};

export const changePassword = (current_password, new_password) =>
    api.post('/auth/change-password', { current_password, new_password }).then((r) => r.data);

